export default __webpack_public_path__ + "static/media/play.12ddce83.png";